import { DataTestConfig } from '@headless-workspace/config';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { DataLayerClassName, TargetedProductCarousel } from '@headless-workspace/domain/common/client';
import { AsyncComponent, EcomConfigKeys, getCachedEcomConfigByKey } from '@headless-workspace/domain/common/server';
import { PropsWithClassName, PropsWithLocale } from '@headless-workspace/glow-ds';

type HomeTargetedProductCarouselSectionProps = PropsWithLocale &
    PropsWithClassName & {
        carouselId: string;
        homeSlotCarouselIds: string[];
        sectionType: string;
    };

export const HomeTargetedProductCarouselSection: AsyncComponent<HomeTargetedProductCarouselSectionProps> = async ({
    carouselId,
    locale,
    className,
    homeSlotCarouselIds,
    sectionType,
}) => {
    const enablePriceLegalMentionsResult = await getCachedEcomConfigByKey(
        locale,
        EcomConfigKeys.EnablePriceLegalMentions,
    );
    const enablePriceExceptionLegalMentions = unwrapResultSuccess(enablePriceLegalMentionsResult) ?? false;

    return (
        <div
            className={DataLayerClassName.targetedCarousel}
            data-testid={`${DataTestConfig.testIds.homeSlotSection}${sectionType}`}
        >
            <TargetedProductCarousel
                homeSlotCarouselIds={homeSlotCarouselIds}
                carouselId={carouselId}
                locale={locale}
                enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
                className={className}
            />
        </div>
    );
};
